var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppContainer',[(_vm.isLoading)?_c('UiLoader'):_c('div',{class:_vm.$style.Content},[(_vm.isErrorText)?_c('div',[_vm._v(_vm._s(_vm.$t(_vm.errorText)))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }